import CloseIcon from "@material-ui/icons/Close"
import MenuIcon from "@material-ui/icons/Menu"
import axios from "axios"
import React, { useEffect, useReducer, useState } from "react"
import { NavLink, Route, BrowserRouter as Router, Switch } from "react-router-dom"
import "./App.css"
import ActiveDriversAndCarsList from "./components/Active_Drivers_and_Cars_List"
import Calendars from "./components/Calendars"
import CarsAndDrivers from "./components/Cars_and_Drivers-list"
import Configurations from "./components/Configurations"
import Contacts from "./components/Contacts"
import CustomerOrders from "./components/CustomerOrderList"
import CustomerList from "./components/Customers_List"
import RideReportsList from "./components/Driver_workShift_Reports"
import Login from "./components/Login"

import { AppBar, Box, Tab, Tabs } from "@material-ui/core"
import PropTypes from "prop-types"
import { CreateNewAdmin } from "./components/CreateNewAdmin"
import CompletedOrdersDriver from "./components/Driver_CompletedOrders_reports"
import { Feedbacks } from "./components/Feebacks"
import OrderTracking from "./components/OrderTracking"
import { SERVER_URI, URL_EXTENSION } from "./utility/config"

function FrontPageWithoutLogin() {
	return (
		<div>
			<h2>Tervetuloa, kirjaudu sisään</h2>
			<Login />
		</div>
	)
}

function TabPanel(props) {
	const { children, value, index, ...other } = props

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}>
			{value === index && <Box p={3}>{children}</Box>}
		</div>
	)
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
}

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	}
}

function reducer(state, action) {
	let deepCopy = JSON.parse(JSON.stringify(state))
	switch (action.type) {
		case "ADD_VEHICLE":
			let vehicles = deepCopy.vehicles
			let newVehicle = action.data.newVehicle
			vehicles.push(newVehicle)
			deepCopy.vehicles = vehicles
			return deepCopy
		case "ADD_DRIVER":
			let drivers = deepCopy.drivers
			let newDriver = action.data.newDriver
			drivers.push(newDriver)
			deepCopy.drivers = drivers
			return deepCopy
		case "ADD_DISCOUNT":
			let discounts = deepCopy.discountRates
			let newDiscount = action.data.newDiscount
			discounts.push(newDiscount)
			deepCopy.discountRates = discounts
			return deepCopy
		case "ADD_CAR_PRIORITY_GROUP":
			let carPriorityGroups = deepCopy.carPriorityTimes
			let newGroup = action.data.newGroup
			carPriorityGroups.push(newGroup)
			deepCopy.carPriorityTimes = carPriorityGroups
			return deepCopy
		case "ADD_WORKSHIFT":
			let workShifts = deepCopy.works
			let newWorkShift = action.data.newShift
			workShifts.push(newWorkShift)
			deepCopy.works = workShifts
			return deepCopy
		case "ADD_TIMED_ORDER_LIMIT":
			deepCopy.timedOrderLimit = action.data.newLimit
			return deepCopy
		case "ADD_EXPIRATION_TIME":
			deepCopy.expirationTime = action.data.newExpirationTime
			return deepCopy
		case "UPDATE_ORDER_PRIORITY_TIME":
			deepCopy.orderPriorityTime = action.data.newOrderPriorityTime
			return deepCopy
		case "ADD_IDLE_ORDER_FORWARD_TIME":
			deepCopy.orderForwardTime = action.data.newOrderForwardTime
			return deepCopy
		case "ADD_WORKSHIFT_TIME":
			deepCopy.workShiftTime = action.data.newWorkShiftTime
			return deepCopy
		case "ADD_CONTACT":
			let contacts = deepCopy.contacts
			let newContact = { ...action.data.newContact, id: action.data.id }
			contacts.push(newContact)
			deepCopy.contacts = contacts
			return deepCopy
		case "ADD_TO_BLACKLIST":
			let blacklist = deepCopy.blacklist
			let newBlacklistedNumber = {
				...action.data.newBlacklistedNumber,
				id: action.data.id,
				adminEmail: action.data.adminEmail,
			}
			blacklist.push(newBlacklistedNumber)
			deepCopy.blacklist = blacklist
			return deepCopy
		case "ADD_TO_WHITELIST":
			let whitelist = deepCopy.whitelist
			let newWhitelistedNumber = {
				...action.data.newWhitelistedNumber,
				id: action.data.id,
			}
			whitelist.push(newWhitelistedNumber)
			deepCopy.blacklist = whitelist
			return deepCopy
		case "ACCEPTED_ORDER":
			let listofOrders = deepCopy.customerOrders
			console.log("ACCEPTED_ORDER", action.data.orderId)
			const indexOfItemInArray = listofOrders.findIndex((q) => q.orderId === action.data.orderId)
			listofOrders[indexOfItemInArray].adminJudgement = "accepted"
			deepCopy.customerOrders = listofOrders
			return deepCopy
		case "REJECTED_ORDER":
			let listofCustomerOrders = deepCopy.customerOrders
			const indexOfItemInArrayReject = listofCustomerOrders.findIndex((q) => q.orderId === action.data.orderId)
			let new_Reject = {
				...listofCustomerOrders[indexOfItemInArrayReject],
				adminJudgement: "rejected",
			}
			listofCustomerOrders.splice(indexOfItemInArrayReject, 1, new_Reject)
			console.log(listofCustomerOrders)
			deepCopy.customerOrders = listofCustomerOrders
			return deepCopy

		case "CANCELLED_ORDER":
			let listofOrdersCancelled = deepCopy.customerOrders
			const indexOfItemInArrayCancelled = listofOrdersCancelled.findIndex((q) => q.orderId === action.data.orderId)
			listofOrdersCancelled[indexOfItemInArrayCancelled].state = "cancelled"
			deepCopy.customerOrders = listofOrdersCancelled
			return deepCopy
		case "MOVE_ORDER_TO_QUEUE":
			let orderQueueCopy = deepCopy.orderQueue
			orderQueueCopy.push(action.data)
			deepCopy.orderQueue = orderQueueCopy
			return deepCopy
		case "REMOVE_ORDER_FROM_QUEUE":
			let orderQueueCopyRemove = deepCopy.orderQueue
			let orderQueueIndex = orderQueueCopyRemove.findIndex((order) => order.id === action.data.id)
			orderQueueCopyRemove.splice(orderQueueIndex, 1)
			deepCopy.orderQueue = orderQueueCopyRemove
			console.log("REMOVE_ORDER_FROM_QUEUE", deepCopy.orderQueue)
			return deepCopy
		case "UPDATE_DEFAULT_REJECT_REASON":
			deepCopy.defaultReason.rejectMessage = action.data.newReason.rejectMessage
			return deepCopy
		case "UPDATE_ADMIN_CREATION_KEY":
			deepCopy.adminCreationKey = action.data.newKey.adminCreationKey
			return deepCopy
		case "UPDATE_CONTACT_PHONE_NUMBER":
			deepCopy.contactPhoneNumber = action.data.newNumber
			return deepCopy
		case "UPDATE_MAX_PASSENGER_COUNT":
			deepCopy.maxPassengerCount = action.data.newMaxPassengerCount
			return deepCopy
		case "UPDATE_CUSTOMER_APP_MIN_VERSION":
			deepCopy.customerAppMinVersion = action.data.minimumVersion
			return deepCopy
		case "UPDATE_DRIVER_APP_MIN_VERSION":
			deepCopy.driverAppMinVersion = action.data.minimumVersion
			return deepCopy
		case "UPDATE_CANCEL_MESSAGE":
			deepCopy.cancelMessage = action.newMessage
			return deepCopy
		case "SET_ORDER_LIMIT":
			const newOrderLimit = action.data.setOrderLimit.orderLimit
			deepCopy.orderLimit = newOrderLimit
			return deepCopy
		case "UPDATE_VEHICLE_PHONENUMBER":
			var indexOfVehiclePhoneNumber = deepCopy.vehicles
				.map(function (x) {
					return x.vehicleId
				})
				.indexOf(action.data.newVehicleInfo.vehicleId)
			deepCopy.vehicles[indexOfVehiclePhoneNumber].phoneNumber = action.data.newVehicleInfo.phoneNumber
			return deepCopy
		case "UPDATE_VEHICLE_REGISTERPLATE":
			var indexOfVehicleRegisterPlate = deepCopy.vehicles
				.map(function (x) {
					return x.vehicleId
				})
				.indexOf(action.data.newVehicleInfo.vehicleId)
			deepCopy.vehicles[indexOfVehicleRegisterPlate].registerPlate = action.data.newVehicleInfo.registerPlate
			return deepCopy
		case "UPDATE_VEHICLE_NUMBEROFSEATS":
			var indexOfVehicleSeats = deepCopy.vehicles
				.map(function (x) {
					return x.vehicleId
				})
				.indexOf(action.data.newVehicleInfo.vehicleId)
			deepCopy.vehicles[indexOfVehicleSeats].numberOfSeats = action.data.newVehicleInfo.numberOfSeats
			return deepCopy
		case "UPDATE_VEHICLE_PRIORITY_GROUP":
			deepCopy.vehicles[action.data.newVehicleInfo.index].priorityGroup = action.data.newVehicleInfo.priorityGroup
			return deepCopy
		case "UPDATE_VEHICLE":
			deepCopy.vehicles[action.data.index] = action.data.newVehicleInfo
			return deepCopy
		case "UPDATE_CUSTOMER_PHONENUMBER":
			var indexOfCustomerPhone = deepCopy.customers
				.map(function (x) {
					return x.customerId
				})
				.indexOf(action.data.newCustomerInfo.customerId)
			deepCopy.customers[indexOfCustomerPhone].phoneNumber = action.data.newCustomerInfo.phoneNumber
			return deepCopy
		case "UPDATE_CUSTOMER_BONUS":
			var indexOfCustomer = deepCopy.customers
				.map(function (x) {
					return x.customerId
				})
				.indexOf(action.data.newCustomerInfo.customerId)
			deepCopy.customers[indexOfCustomer].accumulatedBonus = action.data.newCustomerInfo.bonus
			return deepCopy
		case "UPDATE_ORDER_STATE":
			let indexOfOrder = deepCopy.customerOrders
				.map(function (x) {
					return x.orderId
				})
				.indexOf(action.data.newOrderState.orderId)
			deepCopy.customerOrders[indexOfOrder].state = action.data.newOrderState.state
			return deepCopy
		case "SEARCH_CUSTOMER":
			let newData = action.data.newData
			deepCopy.customers = newData
			return deepCopy
		case "UPDATE_CONTACT":
			const { name, email, phoneNumber, index } = action.data.newContact
			deepCopy.contacts[index].name = name
			deepCopy.contacts[index].email = email
			deepCopy.contacts[index].phoneNumber = phoneNumber
			return deepCopy
		case "DELETE_WORKSHIFT":
			let workShiftId = action.data.workShiftId
			deepCopy.works = deepCopy.works.filter((work) => work.reservedShiftId !== workShiftId)
			return deepCopy
		case "UPDATE_WORKSHIFT":
			let updatedWorkShift = action.data.updatedShift
			deepCopy.works = deepCopy.works.map((work) =>
				work.reservedShiftId === updatedWorkShift.reservedShiftId ? updatedWorkShift : work
			)
			return deepCopy
		case "UPDATE_WORK_SHIFTS":
			let updatedWorkShifts = action.data.updatedWorkShifts
			deepCopy.works = updatedWorkShifts
			return deepCopy
		case "DELETE_EXCLUSION":
			let deleteExclusionTimes = deepCopy.exclusionTimes
			deleteExclusionTimes.splice(action.data.exclusion, 1)
			deepCopy.exclusionTimes = deleteExclusionTimes
			return deepCopy
		case "DELETE_DRIVER":
			let deleteDriver = deepCopy.drivers
			deleteDriver.splice([action.data.driverIndex], 1)
			deepCopy.drivers = deleteDriver
			return deepCopy
		case "REFRESH_DATA":
			deepCopy.vehicles = action.data.vehicles || deepCopy.vehicles
			deepCopy.drivers = action.data.drivers || deepCopy.drivers
			deepCopy.customerOrders = action.data.customerOrders || deepCopy.customerOrders
			deepCopy.listActualWorkShifts = action.data.listActualWorkShifts || deepCopy.listActualWorkShifts
			deepCopy.customers = action.data.customers || deepCopy.customers
			return deepCopy
		case "DELETE_CAR":
			let deleteCar = deepCopy.vehicles
			deleteCar.splice([action.data.vehicleIndex], 1)
			deepCopy.vehicles = deleteCar
			return deepCopy
		case "DELETE_CUSTOMER":
			let delCustomer = deepCopy.customers
			let filtList = delCustomer.filter((item) => action.data.dataToReducer.customerId !== item.customerId)
			deepCopy.customers = filtList
			let newDelCustList = [
				...deepCopy.deletedCustomers,
				{
					customerId: action.data.newId,
					phoneNumber: action.data.dataToReducer.phoneNumber,
					callSign: action.data.dataToReducer.callSign,
					accumulatedBonus: action.data.dataToReducer.accBonus,
				},
			]
			deepCopy.deletedCustomers = newDelCustList
			return deepCopy
		case "RESTORE_CUSTOMER":
			let deletedCustomerList = deepCopy.deletedCustomers
			let newDeletedCustomerList = deletedCustomerList.filter(
				(item) => action.data.dataToReducer.customerId !== item.customerId
			)
			deepCopy.deletedCustomers = newDeletedCustomerList
			let newCustomer = deletedCustomerList.find((item) => item.customerId === action.data.dataToReducer.customerId)
			newCustomer.customerId = action.data.newId
			let newCustomerList = [...deepCopy.customers, newCustomer]
			deepCopy.customers = newCustomerList
			return deepCopy
		case "DELETE_DISCOUNT":
			let deleteDiscount = deepCopy.discountRates
			deleteDiscount.splice([action.data.discountIndex], 1)
			deepCopy.discountRates = deleteDiscount
			return deepCopy
		case "DELETE_CAR_PRIORITY_GROUP":
			let deleteCarPriorityGroup = deepCopy.carPriorityTimes
			deleteCarPriorityGroup.splice([action.data.carPriorityGroupIndex], 1)
			deepCopy.carPriorityTimes = deleteCarPriorityGroup
			return deepCopy
		case "DELETE_PRIORITY_GROUP_FROM_VEHICLES":
			let modifiedVehicles = deepCopy.vehicles.map((vehicle) =>
				vehicle.priorityGroup === action.data ? { ...vehicle, priorityGroup: "" } : vehicle
			)
			deepCopy.vehicles = modifiedVehicles
			return deepCopy
		case "DELETE_CONTACT":
			let newContactList = deepCopy.contacts
			let filteredList = newContactList.filter((item) => action.data.contactId !== item.id)
			deepCopy.contacts = filteredList
			return deepCopy
		case "DELETE_FROM_BLACKLIST":
			let newBlacklist = deepCopy.blacklist
			let filteredBlacklist = newBlacklist.filter((item) => action.data.blacklistId !== item.id)
			deepCopy.blacklist = filteredBlacklist
			return deepCopy
		case "DELETE_FROM_WHITELIST":
			let newWhitelist = deepCopy.whitelist
			let filteredWhitelist = newWhitelist.filter((item) => action.data.whitelistId !== item.id)
			deepCopy.whitelist = filteredWhitelist
			return deepCopy
		case "SET_ORDER_QUEUE":
			deepCopy.orderQueue = action.data.orderQueue
			return deepCopy
		case "SET_FEEDBACKS":
			deepCopy.feedBacks = action.data
			return deepCopy
		case "MARK_FEEDBACK_AS_READ":
			let feedbacks = deepCopy.feedBacks
			feedbacks.find((feedback) => feedback.id === action.data).isRead = true
			deepCopy.feedBacks = feedbacks
			return deepCopy
		case "DELETE_FEEDBACK":
			let feedbacksList = deepCopy.feedBacks
			let filteredFeedbacks = feedbacksList.filter((item) => action.data !== item.id)
			deepCopy.feedBacks = filteredFeedbacks
			return deepCopy
		case "DELETE_ADMIN_ACCOUNT":
			let adminAccounts = deepCopy.adminAccounts
			let filteredAdminAccounts = adminAccounts.filter((item) => action.data.userId !== item.id)
			deepCopy.adminAccounts = filteredAdminAccounts
			return deepCopy
		case "UPDATE_DAY_SHIFT_TIME":
			let updatedDayShiftStart = action.data.dayShiftStart
			let updatedDayShiftEnd = action.data.dayShiftEnd
			deepCopy.dayShiftTime = {
				dayShiftStart: updatedDayShiftStart,
				dayShiftEnd: updatedDayShiftEnd,
			}
			return deepCopy
		case "UPDATE_NIGHT_SHIFT_TIME":
			let updatedNightShiftStart = action.data.nightShiftStart
			let updatedNightShiftEnd = action.data.nightShiftEnd
			deepCopy.nightShiftTime = {
				nightShiftStart: updatedNightShiftStart,
				nightShiftEnd: updatedNightShiftEnd,
			}
			return deepCopy
		case "UPDATE_DRIVER_MAX_SHIFT_RESERVATION_DAYS":
			let updatedDriverMaxShiftReservationDays = action.data.newDriverMaxShiftReservationDays
			deepCopy.driverMaxShiftReservationDays = updatedDriverMaxShiftReservationDays
			return deepCopy
		case "UPDATE_MINIMUM_SHIFT_RESERVATION_TIME":
			let updatedMinimumReservationTime = action.data.newMinimumReservationTime
			deepCopy.minimumReservationTime = updatedMinimumReservationTime
			return deepCopy
		case "UPDATE_MINIMUM_SHIFT_CANCEL_TIME":
			let updatedMinimumCancelTime = action.data.newMinimumCancelTime
			deepCopy.minimumCancelTime = updatedMinimumCancelTime
			return deepCopy
		case "INIT_DATA":
			return {
				vehicles: action.vehicles,
				drivers: action.drivers,
				works: action.works,
				exclusionTimes: action.exclusionTimes,
				customers: action.customers,
				deletedCustomers: action.deletedCustomers,
				/* customerOrders: action.customerOrders, */
				discountRates: action.discountRates,
				timedOrderLimit: action.timedOrderLimit,
				listActualWorkShifts: action.listActualWorkShifts,
				defaultReason: action.defaultReason,
				contacts: action.contacts,
				blacklist: action.blacklist,
				whitelist: action.whitelist,
				expirationTime: action.expirationTime,
				orderPriorityTime: action.orderPriorityTime,
				orderForwardTime: action.orderForwardTime,
				workShiftTime: action.workShiftTime,
				orderLimit: action.orderLimit,
				carPriorityTimes: action.carPriorityTimes,
				orderQueue: action.orderQueue,
				getForwardOrders: action.getForwardOrders,
				setForwardOrders: action.setForwardOrders,
				getCancelOrders: action.getCancelOrders,
				setCancelOrders: action.setCancelOrders,
				cancelMessage: action.cancelMessage,
				adminCreationKey: action.adminCreationKey,
				contactPhoneNumber: action.contactPhoneNumber,
				maxPassengerCount: action.maxPassengerCount,
				customerAppMinVersion: action.customerAppMinVersion,
				driverAppMinVersion: action.driverAppMinVersion,
				feedBacks: action.feedBacks,
				adminAccounts: action.adminAccounts,
				dayShiftTime: action.dayShiftTime,
				nightShiftTime: action.nightShiftTime,
				driverMaxShiftReservationDays: action.driverMaxShiftReservationDays,
				minimumShiftReservationTime: action.minimumShiftReservationTime,
				minimumShiftCancelTime: action.minimumShiftCancelTime,
			}
		default:
			throw new Error()
	}
}

function App() {
	const [token, setToken] = useState()
	const [state, dispatch] = useReducer(reducer, [])
	const [isLoading, setLoading] = useState(true)
	const [value, setValue] = useState(0)

	const handleChange = (event, newValue) => {
		setValue(newValue)
	}

	useEffect(() => {
		const fetchData = async () => {
			console.log("Fetching data")
			let storage = window.localStorage
			let userToken = storage.getItem("admin_token")
			setToken(userToken)
			try {
				let driver,
					vehicle,
					work,
					exclusionTimes,
					customers,
					deletedCustomers,
					customerOrders,
					discountRates,
					contacts,
					blacklist,
					whitelist,
					orderLimit,
					carPriorityTimes
				//Make sure that the Token exists
				if (userToken === null || userToken === undefined) {
					console.log("kirjaudu sisään")
					setLoading(false)
				} else {
					driver = await axios.get(`${SERVER_URI}/list_drivers/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					vehicle = await axios.get(`${SERVER_URI}/list_vehicles/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					work = await axios.get(`${SERVER_URI}/list_reserved_shifts/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					exclusionTimes = await axios.get(`${SERVER_URI}/list_order_exclusion_times/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					customers = await axios.get(`${SERVER_URI}/list_customers/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					deletedCustomers = await axios.get(`${SERVER_URI}/list_deleted_customers`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					customerOrders = await axios.get(`${SERVER_URI}/list_orders/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					discountRates = await axios.get(`${SERVER_URI}/list_discount_rates/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					carPriorityTimes = await axios.get(`${SERVER_URI}/get_car_priority_times/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					contacts = await axios.get(`${SERVER_URI}/list_contacts/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					blacklist = await axios.get(`${SERVER_URI}/get_blacklist`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					whitelist = await axios.get(`${SERVER_URI}/get_whitelist`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					orderLimit = await axios.get(`${SERVER_URI}/get_order_limit`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let orderForwardTime = await axios.get(`${SERVER_URI}/get_order_forward_time/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let limit = await axios.get(`${SERVER_URI}/get_timed_order_limit/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let expirationTime = await axios.get(`${SERVER_URI}/get_expiration_time`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let orderPriorityTime = await axios.get(`${SERVER_URI}/get_order_priority_time`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let workShiftTime = await axios.get(`${SERVER_URI}/get_workshift_time`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let listActualWorkShifts = await axios.get(`${SERVER_URI}/list_actual_work_shifts/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let defaultReason = await axios.get(`${SERVER_URI}/get_default_reject_message/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let cancelMessage = await axios.get(`${SERVER_URI}/get_cancel_message/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let orderQueue = await axios.get(`${SERVER_URI}/get_order_queue/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let getForwardOrders = await axios.get(`${SERVER_URI}/get_forward_orders/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let getCancelOrders = await axios.get(`${SERVER_URI}/get_cancel_orders/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let contactPhoneNumber = await axios.get(`${SERVER_URI}/get_contact_phone_number/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let maxPassengerCount = await axios.get(`${SERVER_URI}/get_max_passenger_count/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let feedBacks = await axios.get(`${SERVER_URI}/get_feedbacks/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let adminAccounts = await axios.get(`${SERVER_URI}/get_admin_accounts/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let dayShiftTime = await axios.get(`${SERVER_URI}/get_day_shift_time/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let nightShiftTime = await axios.get(`${SERVER_URI}/get_night_shift_time/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let driverMaxShiftReservationDays = await axios.get(`${SERVER_URI}/get_driver_max_shift_reservation_days/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let minimumShiftReservationTime = await axios.get(`${SERVER_URI}/get_minimum_shift_reservation_time/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let minimumShiftCancelTime = await axios.get(`${SERVER_URI}/admin_get_minimum_shift_cancel_time/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					let appMinVersions = await axios.get(`${SERVER_URI}/get_app_min_versions/`, {
						headers: { Authorization: `Token ${userToken}` },
					})
					dispatch({
						type: "INIT_DATA",
						vehicles: vehicle.data,
						drivers: driver.data,
						works: work.data,
						exclusionTimes: exclusionTimes.data,
						customers: customers.data,
						deletedCustomers: deletedCustomers.data,
						customerOrders: customerOrders.data,
						discountRates: discountRates.data,
						timedOrderLimit: limit.data,
						expirationTime: expirationTime.data,
						orderForwardTime: orderForwardTime.data.orderForwardTime,
						workShiftTime: workShiftTime.data.workShiftTime,
						listActualWorkShifts: listActualWorkShifts.data,
						defaultReason: defaultReason.data,
						contacts: contacts.data,
						blacklist: blacklist.data,
						whitelist: whitelist.data,
						orderLimit: orderLimit.data.orderLimit,
						carPriorityTimes: carPriorityTimes.data,
						orderQueue: orderQueue.data,
						getForwardOrders: getForwardOrders.data,
						getCancelOrders: getCancelOrders.data,
						cancelMessage: cancelMessage.data,
						contactPhoneNumber: contactPhoneNumber.data.contactPhoneNumber,
						maxPassengerCount: maxPassengerCount.data.maxPassengerCount,
						customerAppMinVersion: appMinVersions.data.customerMinVersion,
						driverAppMinVersion: appMinVersions.data.driverMinVersion,
						feedBacks: feedBacks.data,
						orderPriorityTime: orderPriorityTime.data.orderPriorityTime,
						adminAccounts: adminAccounts.data,
						dayShiftTime: dayShiftTime.data.dayShiftTime,
						nightShiftTime: nightShiftTime.data.nightShiftTime,
						driverMaxShiftReservationDays: driverMaxShiftReservationDays.data.driverMaxShiftReservationDays,
						minimumShiftReservationTime: minimumShiftReservationTime.data.minimumShiftReservationTime,
						minimumShiftCancelTime: minimumShiftCancelTime.data.minimumShiftCancelTime,
					})
					setLoading(false)
				}
			} catch (e) {
				console.log("Error in getting initial data", e)
			}
		}
		fetchData()
	}, [])

	// To stop the frontpage list from refreshing in the background
	const StopListRefresh = () => {
		let i
		for (i = 0; i < 10000; i++) {
			window.clearInterval(i)
		}
	}

	const Logout = () => {
		StopListRefresh()
		let storage = window.localStorage
		let noToken = storage.removeItem("admin_token")
		useEffect(() => {
			setToken(noToken)
		})
		console.log("Token poistettu")
		window.setTimeout(function () {
			// Move to a new location
			window.location.href = `${URL_EXTENSION}`
		}, 1500)
		return <h2>Kirjauduit ulos</h2>
	}

	if (isLoading) {
		return <div className="App">Loading...</div>
	}

	return (
		<Router>
			<div className="App" style={{ minHeight: "100vh", maxHeight: "100vh" }}>
				<NavBar token={token} />
				<Switch>
					<Route exact path={URL_EXTENSION + "calendars"}>
						<Calendars
							driverList={state.drivers}
							workList={state.works}
							dispatch={dispatch}
							vehicleList={state.vehicles}
							exclusionTimes={state.exclusionTimes}
							stopListRefresh={StopListRefresh}
							dayShiftTime={state.dayShiftTime}
							nightShiftTime={state.nightShiftTime}
						/>
					</Route>
					<Route path={URL_EXTENSION + "logout"}>
						<Logout />
					</Route>
					<Route path={URL_EXTENSION + "login"}>
						<Login />
					</Route>
					<Route path={URL_EXTENSION + "drivers_and_cars/driver_reports/:driverId"}>
						<RideReportsList
							listActualWorkShifts={state.listActualWorkShifts}
							dispatch={dispatch}
							stopListRefresh={StopListRefresh}
						/>
					</Route>
					<Route path={URL_EXTENSION + "drivers_and_cars"}>
						<CarsAndDrivers
							vehicleList={state.vehicles}
							driverList={state.drivers}
							priorityGroups={state.carPriorityTimes}
							dispatch={dispatch}
							stopListRefresh={StopListRefresh}
						/>
					</Route>
					<Route path={URL_EXTENSION + "reports"}>
						<CompletedOrdersDriver stopListRefresh={StopListRefresh} driverList={state.drivers} />
					</Route>
					<Route path={URL_EXTENSION + "configurations"}>
						<Configurations
							dispatch={dispatch}
							expirationTime={state.expirationTime}
							orderForwardTime={state.orderForwardTime}
							workShiftTime={state.workShiftTime}
							stopListRefresh={StopListRefresh}
							timedOrderLimit={state.timedOrderLimit}
							discountRatesList={state.discountRates}
							defaultReason={state.defaultReason}
							cancelMessage={state.cancelMessage}
							orderLimit={state.orderLimit}
							blacklist={state.blacklist}
							whitelist={state.whitelist}
							carPriorityTimes={state.carPriorityTimes}
							contactPhoneNumber={state.contactPhoneNumber}
							maxPassengerCount={state.maxPassengerCount}
							customerAppMinVersion={state.customerAppMinVersion}
							driverAppMinVersion={state.driverAppMinVersion}
							orderPriorityTime={state.orderPriorityTime}
							adminAccounts={state.adminAccounts}
							dayShiftTime={state.dayShiftTime}
							nightShiftTime={state.nightShiftTime}
							driverMaxShiftReservationDays={state.driverMaxShiftReservationDays}
							minimumShiftReservationTime={state.minimumShiftReservationTime}
							minimumShiftCancelTime={state.minimumShiftCancelTime}
							vehicleList={state.vehicles}
							driverList={state.drivers}
						/>
					</Route>
					<Route path={URL_EXTENSION + "contacts"}>
						<Contacts dispatch={dispatch} stopListRefresh={StopListRefresh} contactsList={state.contacts} />
					</Route>
					<Route path={URL_EXTENSION + "customers/:customerId"}>
						<CustomerOrders customerOrderList={state.customerOrders} dispatch={dispatch} />
					</Route>
					<Route path={URL_EXTENSION + "customers"}>
						<CustomerList
							dispatch={dispatch}
							customerList={state.customers}
							stopListRefresh={StopListRefresh}
							deletedCustomerList={state.deletedCustomers}
						/>
					</Route>

					<Route path={URL_EXTENSION + "create_new_admin_account"}>
						<CreateNewAdmin />
					</Route>

					<Route path={URL_EXTENSION + "feedback"}>
						<Feedbacks feedBacks={state.feedBacks} dispatch={dispatch} />
					</Route>

					<Route path={URL_EXTENSION}>
						{token === null || token === undefined ? (
							<FrontPageWithoutLogin />
						) : (
							<>
								<AppBar position="relative" style={{ zIndex: 1 }}>
									<Tabs value={value} onChange={handleChange} aria-label="simple tabs example" centered>
										<Tab label="Tilausten seuranta" {...a11yProps(0)} />
										<Tab label="Autot/Kuljettajat" {...a11yProps(1)} />
									</Tabs>
								</AppBar>
								<TabPanel as={"div"} value={value} index={0}>
									<OrderTracking
										dispatch={dispatch}
										orderQueue={state.orderQueue}
										getForwardOrders={state.getForwardOrders}
										setForwardOrders={state.setForwardOrders}
										getCancelOrders={state.getCancelOrders}
										setCancelOrders={state.setCancelOrders}
										orderList={state.customerOrders}
										customerList={state.customers}
									/>
								</TabPanel>
								<TabPanel value={value} index={1}>
									<ActiveDriversAndCarsList
										vehicleList={state.vehicles}
										driverList={state.drivers}
										dispatch={dispatch}
										listActualWorkShifts={state.listActualWorkShifts}
										stopListRefresh={StopListRefresh}
									/>
								</TabPanel>
							</>
						)}
					</Route>
				</Switch>
			</div>
		</Router>
	)
}

const NavBar = React.memo(({ token }) => {
	const [click, setClick] = useState(false)
	const handleClick = () => setClick(!click)
	const closeMobileMenu = () => setClick(false)
	if (token === null) {
		return <header className="App-header">{/* <p>Lomamuutto Oy</p> */}</header>
	} else {
		return (
			<header className="App-header">
				<ul className={click ? "nav-options active" : "nav-options"}>
					<li className="option" onClick={closeMobileMenu}>
						<NavLink exact activeClassName="active" to={URL_EXTENSION}>
							Etusivu
						</NavLink>
					</li>
					<li className="option" onClick={closeMobileMenu}>
						<NavLink activeClassName="active" to={URL_EXTENSION + "calendars"}>
							Kalenteri
						</NavLink>
					</li>
					<li className="option" onClick={closeMobileMenu}>
						<NavLink activeClassName="active" to={URL_EXTENSION + "drivers_and_cars"}>
							Autot ja Kuljettajat
						</NavLink>
					</li>
					<li className="option" onClick={closeMobileMenu}>
						<NavLink activeClassName="active" to={URL_EXTENSION + "customers"}>
							Asiakkaat
						</NavLink>
					</li>
					<li className="option" onClick={closeMobileMenu}>
						<NavLink activeClassName="active" to={URL_EXTENSION + "reports"}>
							Raportit
						</NavLink>
					</li>
					<li className="option" onClick={closeMobileMenu}>
						<NavLink activeClassName="active" to={URL_EXTENSION + "configurations"}>
							Asetukset
						</NavLink>
					</li>
					<li className="option" onClick={closeMobileMenu}>
						<NavLink activeClassName="active" to={URL_EXTENSION + "contacts"}>
							Yhteystiedot
						</NavLink>
					</li>
					<li className="option" onClick={closeMobileMenu}>
						<NavLink activeClassName="active" to={URL_EXTENSION + "feedback"}>
							Palautteet
						</NavLink>
					</li>
					<li className="option" onClick={closeMobileMenu}>
						<NavLink activeClassName="active" to={URL_EXTENSION + "logout"}>
							Kirjaudu ulos
						</NavLink>
					</li>
				</ul>
				<div className="mobile-menu" onClick={handleClick}>
					{click ? (
						<CloseIcon
							style={{
								fontSize: 40,
							}}
							className="menu-icon"
						/>
					) : (
						<MenuIcon
							style={{
								fontSize: 40,
							}}
							className="menu-icon"
						/>
					)}
				</div>
			</header>
		)
	}
})

export default App
